import { encode } from 'vlq';
export default encode;